import React from 'react'

const ProgressBar = () => (
  <div className="progress page-nav-progress fixed-top">
    <div id="page-nav-progress-bar" className="progress-bar" role="progressbar" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
  </div>
)

export default ProgressBar
